module.exports = __webpack_public_path__ + "db111e7d4328a8155c9aa7bc153a6854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_40.jpg
// module id = 1678
// module chunks = 5